module.exports = __webpack_public_path__ + "static/media/6.ee45113e.jpg";